module.exports = __webpack_public_path__ + "img/i24.6c22af1d.png";